module.exports = new __parcel__URL__("cadet_dorm_icon.e86d8014.png").toString();